"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _reactBootstrap = require("react-bootstrap");
var _EmailSubscribeForm = _interopRequireDefault(require("./EmailSubscribeForm"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Renders the MM footer subscribe component
 *
 * @param {object} props sitecore fields Properties used to render the footer subscribe
 *
 * @returns {React.ReactElement} A footer subscribe element
 */
function FooterSubscribeWithForm(props) {
  if (!props.fields) return null;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "mm-footer-subscribe"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "align-items-start"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    md: 6,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "subscribe-msg"
  }, props.fields.SubscribeMessage.value)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    md: 6,
    lg: 5
  }, /*#__PURE__*/_react.default.createElement(_EmailSubscribeForm.default, {
    fields: props.fields,
    params: props.params
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    md: 12,
    lg: 3,
    className: "social-links"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-inline"
  }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "h4"
  }, props.fields.SocialMessage.value)), props.fields.SocialLinks.map(social => {
    var {
      linkUrl,
      linkTarget,
      linkAlt
    } = (0, _linkFieldSrc.linkFieldSrc)(social.fields.TargetLink.value);
    return /*#__PURE__*/_react.default.createElement("li", {
      key: social.id
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: linkUrl,
      target: linkTarget,
      rel: "noopener noreferrer",
      "aria-label": linkAlt
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: social.fields.IconName.value
    })));
  }))))));
}
;
var _default = exports.default = FooterSubscribeWithForm;